import Cookies from 'js-cookie';
import wildcardDomain from '@/js/common/Domain/Service/wildcardDomain';

//Инициализация mindbox
const mindbox = window.mindbox || function () {
    window.mindbox.queue.push(arguments);
};
window.mindbox = mindbox;
mindbox.queue = mindbox.queue || [];

window.mindbox('create', {
    endpointId: 'travelata-webpush',
    pointOfContactSystemName: 'travelata.ru',
    firebaseMessagingSenderId: '306980008454',
});

const isNotificationWindowWasShow = Cookies.get('isNotificationWindowWasShow') === '1';
if (!isNotificationWindowWasShow) {
    setTimeout(
        () => {
            const mindboxWindow = window.mindbox;
            mindboxWindow('webpush.create');
            mindboxWindow("webpush.migrate", {
                migrateOperation: "MigrateWebPush"
            }); 
            mindboxWindow('webpush.subscribe', {
                getSubscriptionOperation: 'GetWebPushSubscription',
                subscribeOperation: 'SubscribeToWebpush',
                onGranted() {
                    Cookies.set('isNotificationWindowWasShow', '1', { domain: wildcardDomain() });
                },
                onDenied() {
                },
            });
        },
        3000,
    );
}

const mindScript = document.createElement('script');
mindScript.src = 'https://api.mindbox.ru/scripts/v1/tracker.js';
mindScript.async = 'true';
document.getElementsByTagName('head')[0].appendChild(mindScript);

export function getUidMindbox() {
    return Cookies.get('mindboxDeviceUUID');
}